import React from 'react';
import { AddressBlock, CustomerDataAddress, StyledLabel } from 'components';
import { ActionLabel, AddressWrapper } from './styled';

export const DefaultAddresses = ({
  addresses,
  handleEditAddress
}: {
  addresses: CustomerDataAddress[];
  handleEditAddress: (addr?: CustomerDataAddress, modalTitle?: string) => void;
}): JSX.Element => {
  const shippingAddress = addresses?.find(address => address.default_shipping);
  const billingAddress = addresses?.find(address => address.default_billing);
  const shippingAddressTitle = 'Shipping Address';
  const billingAddressTitle = 'Billing Address';

  return (
    <>
      {addresses.length && (
        <>
          <AddressWrapper>
            <StyledLabel>Default {billingAddressTitle}</StyledLabel>
            <AddressBlock address={billingAddress} />
            <ActionLabel>
              <span onClick={() => handleEditAddress(billingAddress, billingAddressTitle)}>Edit Address</span>
            </ActionLabel>
          </AddressWrapper>
          <AddressWrapper>
            <StyledLabel>Default {shippingAddressTitle}</StyledLabel>
            <AddressBlock address={shippingAddress} />
            <ActionLabel>
              <span onClick={() => handleEditAddress(shippingAddress, shippingAddressTitle)}>Edit Address</span>
            </ActionLabel>
          </AddressWrapper>
        </>
      )}
    </>
  );
};
